//@ts-nocheck
import { BinaryReader, BinaryWriter } from "../../binary";
import { isSet, bytesFromBase64, base64FromBytes } from "../../helpers";
import { GlobalDecoderRegistry } from "../../registry";
function createBaseDoubleValue() {
    return {
        value: 0
    };
}
export const DoubleValue = {
    typeUrl: "/google.protobuf.DoubleValue",
    is(o) {
        return o && (o.$typeUrl === DoubleValue.typeUrl || typeof o.value === "number");
    },
    isSDK(o) {
        return o && (o.$typeUrl === DoubleValue.typeUrl || typeof o.value === "number");
    },
    isAmino(o) {
        return o && (o.$typeUrl === DoubleValue.typeUrl || typeof o.value === "number");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== 0) {
            writer.uint32(9).double(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDoubleValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? Number(object.value) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDoubleValue();
        message.value = object.value ?? 0;
        return message;
    },
    fromAmino(object) {
        const message = createBaseDoubleValue();
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value === 0 ? undefined : message.value;
        return obj;
    },
    fromAminoMsg(object) {
        return DoubleValue.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return DoubleValue.decode(message.value);
    },
    toProto(message) {
        return DoubleValue.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.DoubleValue",
            value: DoubleValue.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(DoubleValue.typeUrl, DoubleValue);
function createBaseFloatValue() {
    return {
        value: 0
    };
}
export const FloatValue = {
    typeUrl: "/google.protobuf.FloatValue",
    is(o) {
        return o && (o.$typeUrl === FloatValue.typeUrl || typeof o.value === "number");
    },
    isSDK(o) {
        return o && (o.$typeUrl === FloatValue.typeUrl || typeof o.value === "number");
    },
    isAmino(o) {
        return o && (o.$typeUrl === FloatValue.typeUrl || typeof o.value === "number");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== 0) {
            writer.uint32(13).float(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFloatValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? Number(object.value) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseFloatValue();
        message.value = object.value ?? 0;
        return message;
    },
    fromAmino(object) {
        const message = createBaseFloatValue();
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value === 0 ? undefined : message.value;
        return obj;
    },
    fromAminoMsg(object) {
        return FloatValue.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return FloatValue.decode(message.value);
    },
    toProto(message) {
        return FloatValue.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.FloatValue",
            value: FloatValue.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(FloatValue.typeUrl, FloatValue);
function createBaseInt64Value() {
    return {
        value: BigInt(0)
    };
}
export const Int64Value = {
    typeUrl: "/google.protobuf.Int64Value",
    is(o) {
        return o && (o.$typeUrl === Int64Value.typeUrl || typeof o.value === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === Int64Value.typeUrl || typeof o.value === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === Int64Value.typeUrl || typeof o.value === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== BigInt(0)) {
            writer.uint32(8).int64(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInt64Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? BigInt(object.value.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = (message.value || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInt64Value();
        message.value = object.value !== undefined && object.value !== null ? BigInt(object.value.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseInt64Value();
        if (object.value !== undefined && object.value !== null) {
            message.value = BigInt(object.value);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value !== BigInt(0) ? (message.value?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return Int64Value.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return Int64Value.decode(message.value);
    },
    toProto(message) {
        return Int64Value.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.Int64Value",
            value: Int64Value.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(Int64Value.typeUrl, Int64Value);
function createBaseUInt64Value() {
    return {
        value: BigInt(0)
    };
}
export const UInt64Value = {
    typeUrl: "/google.protobuf.UInt64Value",
    is(o) {
        return o && (o.$typeUrl === UInt64Value.typeUrl || typeof o.value === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === UInt64Value.typeUrl || typeof o.value === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === UInt64Value.typeUrl || typeof o.value === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== BigInt(0)) {
            writer.uint32(8).uint64(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUInt64Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? BigInt(object.value.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = (message.value || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUInt64Value();
        message.value = object.value !== undefined && object.value !== null ? BigInt(object.value.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseUInt64Value();
        if (object.value !== undefined && object.value !== null) {
            message.value = BigInt(object.value);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value !== BigInt(0) ? (message.value?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return UInt64Value.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return UInt64Value.decode(message.value);
    },
    toProto(message) {
        return UInt64Value.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.UInt64Value",
            value: UInt64Value.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(UInt64Value.typeUrl, UInt64Value);
function createBaseInt32Value() {
    return {
        value: 0
    };
}
export const Int32Value = {
    typeUrl: "/google.protobuf.Int32Value",
    is(o) {
        return o && (o.$typeUrl === Int32Value.typeUrl || typeof o.value === "number");
    },
    isSDK(o) {
        return o && (o.$typeUrl === Int32Value.typeUrl || typeof o.value === "number");
    },
    isAmino(o) {
        return o && (o.$typeUrl === Int32Value.typeUrl || typeof o.value === "number");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== 0) {
            writer.uint32(8).int32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInt32Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? Number(object.value) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = Math.round(message.value));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseInt32Value();
        message.value = object.value ?? 0;
        return message;
    },
    fromAmino(object) {
        const message = createBaseInt32Value();
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value === 0 ? undefined : message.value;
        return obj;
    },
    fromAminoMsg(object) {
        return Int32Value.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return Int32Value.decode(message.value);
    },
    toProto(message) {
        return Int32Value.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.Int32Value",
            value: Int32Value.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(Int32Value.typeUrl, Int32Value);
function createBaseUInt32Value() {
    return {
        value: 0
    };
}
export const UInt32Value = {
    typeUrl: "/google.protobuf.UInt32Value",
    is(o) {
        return o && (o.$typeUrl === UInt32Value.typeUrl || typeof o.value === "number");
    },
    isSDK(o) {
        return o && (o.$typeUrl === UInt32Value.typeUrl || typeof o.value === "number");
    },
    isAmino(o) {
        return o && (o.$typeUrl === UInt32Value.typeUrl || typeof o.value === "number");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== 0) {
            writer.uint32(8).uint32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUInt32Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? Number(object.value) : 0
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = Math.round(message.value));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUInt32Value();
        message.value = object.value ?? 0;
        return message;
    },
    fromAmino(object) {
        const message = createBaseUInt32Value();
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value === 0 ? undefined : message.value;
        return obj;
    },
    fromAminoMsg(object) {
        return UInt32Value.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return UInt32Value.decode(message.value);
    },
    toProto(message) {
        return UInt32Value.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.UInt32Value",
            value: UInt32Value.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(UInt32Value.typeUrl, UInt32Value);
function createBaseBoolValue() {
    return {
        value: false
    };
}
export const BoolValue = {
    typeUrl: "/google.protobuf.BoolValue",
    is(o) {
        return o && (o.$typeUrl === BoolValue.typeUrl || typeof o.value === "boolean");
    },
    isSDK(o) {
        return o && (o.$typeUrl === BoolValue.typeUrl || typeof o.value === "boolean");
    },
    isAmino(o) {
        return o && (o.$typeUrl === BoolValue.typeUrl || typeof o.value === "boolean");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value === true) {
            writer.uint32(8).bool(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBoolValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? Boolean(object.value) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBoolValue();
        message.value = object.value ?? false;
        return message;
    },
    fromAmino(object) {
        const message = createBaseBoolValue();
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value === false ? undefined : message.value;
        return obj;
    },
    fromAminoMsg(object) {
        return BoolValue.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return BoolValue.decode(message.value);
    },
    toProto(message) {
        return BoolValue.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.BoolValue",
            value: BoolValue.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(BoolValue.typeUrl, BoolValue);
function createBaseStringValue() {
    return {
        value: ""
    };
}
export const StringValue = {
    typeUrl: "/google.protobuf.StringValue",
    is(o) {
        return o && (o.$typeUrl === StringValue.typeUrl || typeof o.value === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === StringValue.typeUrl || typeof o.value === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === StringValue.typeUrl || typeof o.value === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStringValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? String(object.value) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseStringValue();
        message.value = object.value ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseStringValue();
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value === "" ? undefined : message.value;
        return obj;
    },
    fromAminoMsg(object) {
        return StringValue.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return StringValue.decode(message.value);
    },
    toProto(message) {
        return StringValue.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.StringValue",
            value: StringValue.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(StringValue.typeUrl, StringValue);
function createBaseBytesValue() {
    return {
        value: new Uint8Array()
    };
}
export const BytesValue = {
    typeUrl: "/google.protobuf.BytesValue",
    is(o) {
        return o && (o.$typeUrl === BytesValue.typeUrl || o.value instanceof Uint8Array || typeof o.value === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === BytesValue.typeUrl || o.value instanceof Uint8Array || typeof o.value === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === BytesValue.typeUrl || o.value instanceof Uint8Array || typeof o.value === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.value.length !== 0) {
            writer.uint32(10).bytes(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBytesValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseBytesValue();
        message.value = object.value ?? new Uint8Array();
        return message;
    },
    fromAmino(object) {
        const message = createBaseBytesValue();
        if (object.value !== undefined && object.value !== null) {
            message.value = bytesFromBase64(object.value);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.value = message.value ? base64FromBytes(message.value) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return BytesValue.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return BytesValue.decode(message.value);
    },
    toProto(message) {
        return BytesValue.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/google.protobuf.BytesValue",
            value: BytesValue.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(BytesValue.typeUrl, BytesValue);
